<template>
  <v-container fluid class="pa-0">
    <!-- <CalendarNavigation
      v-model:week-offset="weekOffset"
      :selected-year="selectedYear"
      :turnosChanged="turnosChanged"
      :selected-user-id="selectedUser?.id"
      :showSaveButton="false"
      @export="saveTurnos"
      @yearChange="handleYearChange"
      @weekChanged="handleWeekChange"
      @previsionModeChanged="handlePrevisionModeChanged"
    /> -->

    <ViewAndShiftsTable
      v-model:week-offset="weekOffset"
      :selected-year="selectedYear"
      :time-slots="turnosStore.timeSlots"
      :schedules="schedules"
      :users="turnosStore.users"
      :puestoId="props.puestoId"
      :read-only="true"
    />

    <!-- Nuevo componente modal -->
    <VacacionesModal
      v-model="showVacacionesModal"
      :vacaciones="vacacionesPorMes"
      :year="selectedYear"
      :selected-user="selectedUser"
    />

    <ConfirmationDialog
      title="Hay cambios sin guardar"
      content="Si continúas, se perderán los cambios."
      v-model="showModal"
      :puestoId="props.puestoId"
      @confirm="onModalConfirm"
      @cancel="onModalCancel"
    />
  </v-container>
</template>

<script setup>
console.log('Component setup initialized')
import { ref, onMounted, onUnmounted, watch } from 'vue'
// import CalendarNavigation from './subcomponents/CalendarNavigation.vue'
import ViewAndShiftsTable from './subcomponents/ViewAndShiftsTable.vue'
import { useTurnosStore } from '@/stores/turnosStore'
import { getISOWeekNumber, getTodayDate } from '@/utils/helpers'
import ConfirmationDialog from '../common/ConfirmationDialog.vue'
import { useRouter } from 'vue-router'
import VacacionesModal from './subcomponents/VacacionesModal.vue'
// import { useDialog } from 'path/to/dialog/composable'
// Estado reactivo
const selectedUser = ref(null)
const schedules = ref({})
const weekOffset = ref(0)
const turnosStore = useTurnosStore()

// Calcular el año ISO inicial
const initialToday = getTodayDate()
const initialTempDate = new Date(initialToday)
initialTempDate.setDate(
  initialTempDate.getDate() + 3 - ((initialTempDate.getDay() + 6) % 7)
)
const selectedYear = ref(initialTempDate.getFullYear())
const showModal = ref(false)
const showVacacionesModal = ref(false)
const vacacionesPorMes = ref(Array(12).fill(0))
// controlamos si hubo cambios en los turnos
const turnosChanged = ref(false)
// Estado para el modo de previsión
// const previsionMode = ref(false)

const router = useRouter()
const previousRoute = ref(null)

const props = defineProps({
  puestoId: {
    type: String,
    required: false
  }
})

// Métodos

onMounted(async () => {
  turnosStore.setTimeSlotsPuesto(props.puestoId)
  const today = getTodayDate()

  // Calcular el año ISO de la semana
  const tempDate = new Date(today)
  tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7))
  selectedYear.value = tempDate.getFullYear()
  weekOffset.value = Math.max(1, getISOWeekNumber(today))

  console.log(
    '🧪 ViewShiftsAll onMounted - Año ISO:',
    selectedYear.value,
    '| Semana:',
    weekOffset.value
  )
  // Guardamos la ruta inicial
  previousRoute.value = router.currentRoute.value.path
  setTimeout(async () => {
    console.log('initializeData desde onMounted')
    await initializeData()
  }, 500)
})

onUnmounted(() => {
  console.log('Component unmounted')
})

const getDateKey = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

// const saveTurnos = async () => {
//   const formattedSchedules = []
//   Object.entries(schedules.value).forEach(([date, daySchedules]) => {
//     Object.entries(daySchedules).forEach(([slotId, users]) => {
//       users.forEach((user) => {
//         formattedSchedules.push({
//           fecha: date,
//           usuario_id: user.id,
//           turno: slotId,
//           prevision: user.prevision || false
//         })
//       })
//     })
//   })

//   try {
//     // console.log('formattedSchedules', formattedSchedules)
//     await turnosStore.saveTurnos(formattedSchedules)
//     turnosChanged.value = false
//     // Opcional: Mostrar mensaje de éxito
//   } catch (error) {
//     console.error('Error saving schedules:', error)
//     // Opcional: Mostrar mensaje de error
//   }
// }

function getMondayOfWeek(weekNumber, year) {
  // Asegurarnos de que weekNumber sea válido
  const validWeekNumber = Math.max(1, Math.min(53, weekNumber || 1))

  const firstDayOfYear = new Date(year, 0, 1)
  const firstDayOfWeek = firstDayOfYear.getDay()
  const daysToFirstThursday = (11 - firstDayOfWeek) % 7
  const firstThursday = new Date(year, 0, 1 + daysToFirstThursday)
  const firstMonday = new Date(firstThursday)
  firstMonday.setDate(firstThursday.getDate() - 3)
  const targetMonday = new Date(firstMonday)
  targetMonday.setDate(firstMonday.getDate() + (validWeekNumber - 1) * 7)

  return targetMonday
}

const initializeData = async () => {
  try {
    selectedUser.value = null

    currentLoadedPosition.value = props.puestoId
    const firstDay = getMondayOfWeek(weekOffset.value, selectedYear.value)
    const fecha = getDateKey(firstDay)
    schedules.value = await turnosStore.fetchTurnos(props.puestoId, fecha)
  } catch (error) {
    console.error('Error initializing data:', error)
  }
}

const onModalConfirm = async () => {
  showModal.value = false
  // if (pendingOperation) {
  turnosChanged.value = false
  console.log('Cambió puestoId de', props.puestoId)
  await initializeData()
  // pendingOperation = null
  // }
}

const onModalCancel = () => {
  showModal.value = false
  // pendingOperation = null
  // Volvemos a la ruta anterior
  if (previousRoute.value) {
    router.push(previousRoute.value)
  }
}

const currentLoadedPosition = ref(null)

// const handleYearChange = async (year) => {
//   selectedYear.value = year

//   // Si el año es el actual, mantener la semana actual
//   // Si no, empezar desde la semana 1
//   if (year === new Date().getFullYear()) {
//     weekOffset.value = getISOWeekNumber(new Date())
//   } else {
//     weekOffset.value = 1 // Resetear a la primera semana del año
//   }

//   await initializeData()
// }

// const handleWeekChange = async (newWeek) => {
//   weekOffset.value = newWeek
//   await initializeData()
// }

// const handlePrevisionModeChanged = (mode) => {
//   previsionMode.value = mode
//   console.log('Modo previsión:', mode)
// }

// Añadimos el watcher para puestoId
watch(
  () => props.puestoId,
  async (newValue, oldValue) => {
    turnosStore.setTimeSlotsPuesto(newValue)

    if (newValue !== oldValue && newValue !== currentLoadedPosition.value) {
      previousRoute.value = oldValue
        ? `/turnos/asignar-turnos/${oldValue}`
        : '/turnos/asignar-turnos'
      if (turnosChanged.value) {
        showModal.value = true
        return
      }
      console.log('Cambió puestoId de', oldValue, 'a', newValue)

      await initializeData()
    }
  }
)
</script>
